import { jsx, jsxs } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { Icon } from '../Icon/Icon.js';
import '@react-icons/all-files/bs/BsLayersFill.js';
import '@react-icons/all-files/bs/BsStars.js';
import '@react-icons/all-files/cg/CgSidebarOpen.js';
import '@react-icons/all-files/cg/CgSidebarRight.js';
import '@react-icons/all-files/fa/FaChevronDown.js';
import '@react-icons/all-files/fa/FaRedditSquare.js';
import '@react-icons/all-files/fa/FaSalesforce.js';
import '@react-icons/all-files/fa/FaSlack.js';
import '@react-icons/all-files/fa/FaTelegram.js';
import '@react-icons/all-files/fa6/FaSquareXTwitter.js';
import '@react-icons/all-files/md/MdAdd.js';
import '@react-icons/all-files/md/MdCheck.js';
import '@react-icons/all-files/md/MdClose.js';
import '@react-icons/all-files/md/MdEmail.js';
import '@react-icons/all-files/md/MdErrorOutline.js';
import '@react-icons/all-files/md/MdHelpOutline.js';
import '@react-icons/all-files/md/MdInfoOutline.js';
import '@react-icons/all-files/md/MdLanguage.js';
import '@react-icons/all-files/md/MdLink.js';
import '@react-icons/all-files/md/MdMoreVert.js';
import '@react-icons/all-files/md/MdOutlineThumbDown.js';
import '@react-icons/all-files/md/MdOutlineThumbUp.js';
import '@react-icons/all-files/md/MdOutlineWarningAmber.js';
import '@react-icons/all-files/md/MdPerson.js';
import '@react-icons/all-files/md/MdPhone.js';
import '@react-icons/all-files/md/MdShare.js';
import '@react-icons/all-files/rx/RxExternalLink.js';
import { Stack } from '../Stack/Stack.js';
import styles from './Button.module.css.js';

const Button = forwardRef(function Button({ label, prominence = "secondary", intent = "action", size = "base", align = "center", fullWidth = false, disabled = false, icon, asIcon, loading = false, submit = false, href, onClick, }, ref) {
    // TODO: We should switch `a` here to `Link` from React Router.
    const Tag = href ? "a" : "button";
    let type;
    if (!href) {
        type = submit ? "submit" : "button";
    }
    return (jsx(Tag, { ref: ref, className: clsx(styles.Button, styles[prominence], styles[intent], styles[size], {
            [styles.fullWidth]: fullWidth,
            [styles.loading]: loading,
            [styles.alignLeft]: align === "left",
        }), disabled: disabled, href: href, onClick: onClick, "aria-label": label, type: type, children: jsxs(Stack, { direction: "row", alignItems: "center", spacing: "small", "aria-hidden": "true", children: [icon ?
                    jsx(Icon, { name: icon, size: size })
                    : null, !asIcon && jsx("div", { "aria-hidden": "true", children: label })] }) }));
});

export { Button };
//# sourceMappingURL=Button.js.map
